import * as React from 'react';

import { Text, TextProps } from '.';

export interface BaseTextProps extends TextProps {}

export const BaseText: React.FC<BaseTextProps> = (props) => {
  return <Text component="p" size="sm" {...props} />;
};
